export enum DiscoveryComponentType {
    BookingButton = 1,
    BookingBar = 2,
    DiscoveryBar = 3,
    ExperienceRiver = 4
}
